import { render, staticRenderFns } from "./OurServiceDigital.vue?vue&type=template&id=03b6eb5c&scoped=true"
import script from "./OurServiceDigital.vue?vue&type=script&lang=js"
export * from "./OurServiceDigital.vue?vue&type=script&lang=js"
import style0 from "./OurServiceDigital.vue?vue&type=style&index=0&id=03b6eb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6eb5c",
  null
  
)

export default component.exports